module.exports = __webpack_public_path__ + "img/medium-white.db59c084.svg";